import lineOffset from './lineOffset.js';
import lineIntersect from './lineIntersect.js';
import lineToPolygon from './lineToPolygon.js';
import difference from './difference.js';
import booleanWithin from './booleanWithin.js';
import turfLineString from './turfLineString.js';
import turfPolygon from './turfPolygon.js';
import turfPoint from './turfPoint.js';
import getCoords from './getCoords.js';

/**
 * Cuts a Polygon or MultiPolygon into smaller pieces using a LineString.
 * Creates offset lines on both sides to define a "cut band" and clips each side separately.
 *
 * @param {GeoJSON.Feature<GeoJSON.Polygon|GeoJSON.MultiPolygon>} polygonFeature - Input polygon.
 * @param {GeoJSON.Feature<GeoJSON.LineString>} cuttingLine - LineString feature used for cutting.
 * @param {string} [idPrefix=''] - Prefix for assigning IDs to resulting polygons.
 * @returns {GeoJSON.Feature<GeoJSON.Polygon>[]|null} Array of resulting polygon features or null if no valid cut.
 */
export default function cutPolygonV1(polygon, line, idPrefix = '') {
  const THICK_LINE_UNITS = 'meters';
    const THICK_LINE_WIDTH = 0.001;
    var i, j, id, intersectPoints, lineCoords, forCut, forSelect;
    var thickLineString, thickLinePolygon, clipped, polyg, intersect;
    var polyCoords = [];
    var cutPolyGeoms = [];
    var cutFeatures = [];
    var offsetLine = [];
    var retVal = null;

    if (((polygon.type != 'Polygon') && (polygon.type != 'MultiPolygon')) || (line.type != 'LineString')) {
        return retVal;
    }

    if (typeof (idPrefix) === 'undefined') {
        idPrefix = '';
    }

    intersectPoints = lineIntersect(polygon, line);
    if (intersectPoints.features.length == 0) {
        return retVal;
    }

    var lineCoords = getCoords(line);
    if ((booleanWithin(turfPoint(lineCoords[0]), polygon) ||
        (booleanWithin(turfPoint(lineCoords[lineCoords.length - 1]), polygon)))) {
        return retVal;
    }

    offsetLine[0] = lineOffset(line, THICK_LINE_WIDTH, { units: THICK_LINE_UNITS });
    offsetLine[1] = lineOffset(line, -THICK_LINE_WIDTH, { units: THICK_LINE_UNITS });

    for (i = 0; i <= 1; i++) {
        forCut = i;
        forSelect = (i + 1) % 2;
        polyCoords = [];
        for (j = 0; j < line.coordinates.length; j++) {
            polyCoords.push(line.coordinates[j]);
        }
        for (j = (offsetLine[forCut].geometry.coordinates.length - 1); j >= 0; j--) {
            polyCoords.push(offsetLine[forCut].geometry.coordinates[j]);
        }
        polyCoords.push(line.coordinates[0]);

        thickLineString = turfLineString(polyCoords);
        thickLinePolygon = lineToPolygon(thickLineString);
        clipped = difference(polygon, thickLinePolygon);

        cutPolyGeoms = [];
        for (j = 0; j < clipped.geometry.coordinates.length; j++) {
            polyg = turfPolygon(clipped.geometry.coordinates[j]);
            intersect = lineIntersect(polyg, offsetLine[forSelect]);
            if (intersect.features.length > 0) {
                cutPolyGeoms.push(polyg.geometry.coordinates);
            };
        };

        cutPolyGeoms.forEach(function (geometry, index) {
            id = idPrefix + (i + 1) + '.' + (index + 1);
            cutFeatures.push(turfPolygon(geometry, { id: id }));
        });
    }

    return cutFeatures;
}
